
import { Component, effect, Input, OnChanges, OnInit, Output, signal, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngrx/store';
import * as fromUnits from 'app/state/units';
import * as fromBeverage from 'app/state/beverage';
import { IBeverage, IBeverageVM } from 'app/models/beverage';
import { ICan } from 'app/models/can';
import { EventEmitter } from 'stream';
import * as dateHelper from 'app/helpers/date.helpers';
import { UnitsHelper } from 'app/services/units.helper';

@Component({
  selector: 'app-can',
  templateUrl: './can.component.html',
  styleUrls: ['./can.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    RouterModule
]
})
export class CanComponent implements OnChanges {


  unitTypes = this.store.selectSignal(fromUnits.getUnits);
  beverages = this.store.selectSignal(fromBeverage.selectAllEntities);
  @Input() can: ICan | undefined;
  @Input() searchPhrase!: string;

  dateHelper = dateHelper;
  today = new Date();

  display = signal(true);

  beverage: IBeverage | undefined = undefined;

  constructor(
    private store: Store,
  ) {
    effect(() => {
      const beverageEntites = this.beverages();
      if (beverageEntites && this.can) {
        this.beverage = beverageEntites[this.can.beverageId];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.can && this.beverage) {
      if (this.searchPhrase) {
        this.display.set(this.beverage.name.toLowerCase().includes(this.searchPhrase.toLowerCase()));
      } else {
        this.display.set(true);
      }
    }

  }

}
